import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { Subscription } from 'rxjs';

declare var decimalInput: any;

@Component({
  selector: 'app-multi',
  templateUrl: './multi.html',
  styleUrls: ['./multi.scss']
})

export class Multi implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public context = "";
  public supplementary = "";  
  public questionId = 0;
  public allClosed = true;

  private loadAnswersSubscription : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    this.loadAnswersSubscription = this.dataSvc.getLoadMultiAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }

  ngOnInit(): void {
    this.loadAnswers();
  }
  
  loadAnswers() {
    this.reloadAnswers();
  }

  reloadAnswers(){
    if(this.dataSvc.currentQuestion().Question.QuestionType !== 1 && this.dataSvc.currentQuestion().Question.QuestionType !== 2 && this.dataSvc.currentQuestion().Question.QuestionType !== 3) return;

    var currentQs = this.dataSvc.currentQuestion();
    currentQs.QuestionResponses.forEach(x => delete x.Checked);
    if(currentQs.Result.Selection !== ""){
      if(currentQs.Question.QuestionType == 3){
        var mcs = currentQs.Result.Selection.split(",");
        if(mcs.length > 0){
          for(var i = 0; i < mcs.length; i++){
            if(mcs[i] !== ""){
              var response = currentQs.QuestionResponses.filter(x => x.Response.AnswerId === parseInt(mcs[i]))[0];
              if(response !== null && response !== undefined){
                response.Checked = true;
              }
            }
          }
        }
      } else {
        var response = currentQs.QuestionResponses.filter(x => x.Response.AnswerId === parseInt(currentQs.Result.Selection))[0];
        if(response !== null && response !== undefined){
          response.Checked = true;
        }
      }
    }

    if (currentQs.Result.MediaViewCount) {
      currentQs.Result._MediaViewCount = new Map(JSON.parse(currentQs.Result.MediaViewCount));
    }
    
    setTimeout(() => {
      for (let i = 0; i < currentQs.QuestionResponses.length; i++) {
        if (this.getResponseMedia(currentQs.QuestionResponses[i], 2) && this.dataSvc.isMediaLimitReached(currentQs.QuestionResponses[i].Response.AnswerId, this.getResponseMedia(currentQs.QuestionResponses[i], 2).MediaId)) {
          document.getElementById(`video-${response.Response.AnswerId}-${this.getResponseMedia(currentQs.QuestionResponses[i], 2).MediaId}`).classList.add("disabled-media");
        }
        if (this.getResponseMedia(currentQs.QuestionResponses[i], 3) && this.dataSvc.isMediaLimitReached(currentQs.QuestionResponses[i].Response.AnswerId, this.getResponseMedia(currentQs.QuestionResponses[i], 3).MediaId)) {
          document.getElementById(`audio-${response.Response.AnswerId}-${this.getResponseMedia(currentQs.QuestionResponses[i], 3).MediaId}`).classList.add("disabled-media");
        }
      }
    }, 1000);
  }

  public getResponseMedia(response, mediaTypeId) {
    if(response.Media != null){
    return response.Media.find(m => m.MediaTypeId === mediaTypeId);    
    }
    return null;
  }

  public isSubtitlesEnabled(response, mediaTypeId) {
    var media = this.getResponseMedia(response, mediaTypeId);
    if(media !== null && media !== undefined){
      if(media.SubtitleUrl !== null && media.SubtitleUrl !== undefined && media.SubtitleUrl !== ""){
        return this.dataSvc.currentUser.ScheduleCandidate.SubtitlesAllowed
      }
    }
    return false;

  }
}
